/**
 * Open Files Directive
 *
 * @example
 * v-open-files.multiple.image="openedCallback"
 */
const openFiles = {
  bind(el, binding, vnode) {
    const $vm = vnode.context

    const fileChosen = function() {
      const items = []
      const onCompleted = files => {
        if (binding.expression) {
          $vm[binding.expression](files)
        }
      }
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i]
        const item = {
          data: file,
        }
        items.push(item)
        onCompleted(items)
        // const reader = new window.FileReader()
        // reader.onerror = (e) => {
        //   console.log('upload file error', e)
        // }
        // reader.onload = () => {
        //   item.url = window.URL.createObjectURL(file)
        //   if (i === this.files.length - 1) {
        //     onCompleted(items)
        //   }
        // }
        // reader.readAsDataURL(file)
      }
    }

    const chooseFile = function(e) {
      const input = document.createElement('INPUT')
      input.setAttribute('type', 'file')
      // Modifiers
      if (binding.modifiers.multiple) {
        input.setAttribute('multiple', 'multiple')
      }
      if (binding.modifiers.image) {
        const imageMimes = [
          'image/gif',
          'image/jpeg',
          'image/png',
          'image/svg+xml',
          'image/webp',
        ]
        input.setAttribute('accept', imageMimes.join(','))
      }
      if (binding.modifiers.video) {
        const videoMimes = ['video/mp4', 'video/ogg', 'video/webm', 'video/quicktime']
        input.setAttribute('accept', videoMimes.join(','))
      }
      if (binding.modifiers.audio) {
        const audioMimes = [
          'audio/aac',
          'audio/flac',
          'audio/mp3',
          'audio/mpeg',
          'audio/mpeg3',
          'audio/ogg',
          'audio/wav',
          'audio/wave',
          'audio/webm',
          'audio/x-aac',
          'audio/x-flac',
          'audio/x-mp3',
          'audio/x-mpeg',
          'audio/x-mpeg3',
          'audio/x-pn-wav',
          'audio/x-wav',
        ]
        input.setAttribute('accept', audioMimes.join(','))
      }
      input.setAttribute('style', 'display: none;')
      el.parentNode.appendChild(input)
      input.addEventListener('change', fileChosen, false)
      // Auto fire the event
      const evt = document.createEvent('MouseEvent')
      evt.initMouseEvent(
        'click',
        true,
        true,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null,
      )
      input.dispatchEvent(evt)
    }

    el.addEventListener('click', e => {
      if (el.classList.contains('is-loading')) {
        return
      }
      chooseFile(e)
    })
  },
}

function install(Vue) {
  Vue.directive('open-files', openFiles)
}

// TODO: Add upload mixin (including event bus), support drag and drop
export default {install}
